/**
 * First-touch attribution (localStorage) + session id.
 * Persists first landing URL / UTM / click ids once per browser.
 */

const FT_KEY = 'sati_lead_first_touch';
const SID_KEY = 'sati_lead_session_id';

const TRACK_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'fbclid',
  'msclkid',
  'ttclid',
];

export function initLeadAttribution() {
  if (typeof window === 'undefined') return;

  let existing = null;
  try {
    existing = localStorage.getItem(FT_KEY);
  } catch {
    return;
  }
  if (existing) return;

  const params = new URLSearchParams(window.location.search);
  const ref = document.referrer || '';

  const payload = {
    captured_at: new Date().toISOString(),
    landing_path: `${window.location.pathname}${window.location.search}`,
    landing_url: window.location.href,
    referrer: ref,
    referrer_domain: (() => {
      try {
        return ref ? new URL(ref).hostname : '';
      } catch {
        return '';
      }
    })(),
  };
  TRACK_PARAMS.forEach((k) => {
    const v = params.get(k);
    if (v) payload[k] = v;
  });

  try {
    localStorage.setItem(FT_KEY, JSON.stringify(payload));
  } catch {
    /* quota / private mode */
  }
}

export function getFirstTouch() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = localStorage.getItem(FT_KEY);
    if (!raw) return {};
    const o = JSON.parse(raw);
    return o && typeof o === 'object' ? o : {};
  } catch {
    return {};
  }
}

export function getSessionId() {
  if (typeof window === 'undefined') return '';
  try {
    let s = sessionStorage.getItem(SID_KEY);
    if (!s) {
      s = `sid_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
      sessionStorage.setItem(SID_KEY, s);
    }
    return s;
  } catch {
    return '';
  }
}

export function getCurrentTouch() {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  const ref = typeof document !== 'undefined' ? document.referrer || '' : '';
  const touch = {
    path: `${window.location.pathname}${window.location.search}`,
    full_url: window.location.href,
    referrer: ref,
    referrer_domain: (() => {
      try {
        return ref ? new URL(ref).hostname : '';
      } catch {
        return '';
      }
    })(),
  };
  TRACK_PARAMS.forEach((k) => {
    const v = params.get(k);
    if (v) touch[k] = v;
  });
  return touch;
}

export function buildSourceSummaryClient(firstTouch, currentTouch) {
  if (currentTouch.gclid || firstTouch.gclid) return 'paid_search (gclid)';
  if (currentTouch.fbclid || firstTouch.fbclid) return 'paid_social (fbclid)';
  if (currentTouch.msclkid || firstTouch.msclkid) return 'paid_search (msclkid)';
  if (currentTouch.ttclid || firstTouch.ttclid) return 'paid_social (ttclid)';
  const utm =
    currentTouch.utm_source ||
    firstTouch.utm_source ||
    currentTouch.utm_medium ||
    firstTouch.utm_medium;
  if (utm) {
    return [currentTouch.utm_source || firstTouch.utm_source, currentTouch.utm_medium || firstTouch.utm_medium, currentTouch.utm_campaign || firstTouch.utm_campaign]
      .filter(Boolean)
      .join(' / ');
  }
  const rd = currentTouch.referrer_domain || firstTouch.referrer_domain;
  const referrer = currentTouch.referrer || firstTouch.referrer;
  if (!referrer && !rd) return 'direct';
  if (rd && /google\./i.test(rd)) return 'organic / google';
  if (rd && /facebook\.|instagram\.|t\.co|linkedin\./i.test(rd)) return `social / ${rd}`;
  return rd ? `referral / ${rd}` : 'referral';
}
